import React, { useEffect } from 'react';

import ReviewStore from '@/stores/review';

import StarRating from '@/common/star-rating';

import doLog from '../../../common/log';

import './index.less';

const FAIL_CODE = '603';
export default function CommentInfo({
  i18n,
  productId,
  companyId,
}: {
  i18n: DetailTypes.i18n;
  productId: number;
  companyId: number;
}) {
  const reviewStore = ReviewStore(state => state);

  const review = reviewStore.review;

  //totalCount为string，totalBuyers为number
  const { averageStar, totalReviewOrderCount, code = '' } = review.product;
  const score = averageStar && parseFloat(averageStar);

  useEffect(() => {
    reviewStore.fetchOverview({
      type: 'product',
      productId,
      companyId,
    });
  }, []);

  //渲染review信息
  const renderReview = () => {
    // 判断reviewInfo是否为{}
    if (Object.keys(review).length === 0) return null;
    //totalCount可能会返回很慢，逻辑提前
    if (totalReviewOrderCount) {
      return (
        <div className="detail-separator">
          <span
            className="detail-review"
            onClick={() => {
              doLog('/sc.details.top_reviews');
            }}
          >
            {`${totalReviewOrderCount} `}
            {parseInt(totalReviewOrderCount) > 1
              ? i18n['detail_discuss.reviews'] || 'reviews'
              : i18n['detail_discuss.review'] || 'review'}
          </span>
        </div>
      );
    }
    // 判断reviewInfo是否为{code: "603",message: "not exist review"}
    if (code === FAIL_CODE) {
      return (
        <div className="detail-no-review detail-separator">
          {i18n['pc_fantasy_no_review_top'] || 'No reviews yet'}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="detail-quick-comment">
      {score && (
        <div className="detail-star detail-separator">
          <StarRating rating={score} />
          {averageStar}
        </div>
      )}
      {renderReview()}
    </div>
  );
}
